export default function Section4() {
    return (
        <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20">
            <h1 className="text-black text-center text-[32px] md:text-[42px] font-bold mb-10 leading-[32px] md:leading-[41px]">
                SEO Services in the UAE
            </h1>
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">

                {/* Left Side - Text */}
                <div className="md:w-1/2 text-center md:text-left mt-10">

                    <h2 className="text-[24px] md:text-[32px] font-bold text-[#1a1a1a] mb-6 leading-[32px] md:leading-[41px]">
                        Get Found Online with Expert SEO Services in Dubai, Abu Dhabi & Across the UAE
                    </h2>
                    <p className="text-gray-600 mb-8">
                        Is your website not ranking on Google? Struggling with low traffic or poor conversions? At Mean3, we offer data-driven SEO strategies tailored to your business goals. Our UAE-focused SEO services help you drive organic traffic, increase visibility, and grow your revenue.
                    </p>

                    {/* CTA Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start mb-10">
                        {/* <a
                            href="https://mean3.com/contact-mean3/"
                            className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
                        >
                            Get Your Free SEO Audit
                        </a> */}
                        <a
                            href="https://mean3.com/contact-mean3/"
                            className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
                        >
                            Schedule a Strategy Call
                        </a>
                    </div>
                </div>

                {/* Right Side - Hero Image */}
                <div className="md:w-1/2 flex justify-center">
                    <img
                        src="/assets/seo-hero.png" // Replace with your hero image path
                        alt="SEO Hero Illustration"
                        className="w-[90%] md:w-[100%] h-auto rounded-lg shadow-lg"
                    />
                </div>
            </div>

            {/* Problem Statement + Issues List */}
            <div className="max-w-6xl mx-auto mt-20 flex flex-col md:flex-row-reverse items-center gap-12">
                {/* Right Side - Existing SEO image */}
                <div className="md:w-1/2">
                    <img
                        src="/assets/SEO.jpg"
                        alt="SEO Problem Illustration"
                        className="w-full h-auto rounded-lg shadow-lg"
                    />
                </div>

                {/* Left Side - Content */}
                <div className="md:w-1/2 text-center md:text-left">
                    <h3 className="text-2xl font-bold text-[#151515] mb-6">
                        Is Your Website Invisible Online?
                    </h3>
                    <p className="text-gray-600 mb-8">
                        Many businesses in the UAE face common SEO challenges that affect their search rankings and online visibility. Without proper SEO, your competitors might be taking your potential customers, even if your products and services are better.
                    </p>

                    {/* Issues List */}
                    <ul className="space-y-5 mb-8">
                        <li className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                                ✓
                            </div>
                            <p className="text-gray-800 font-medium">Your website is not showing up in search results</p>
                        </li>
                        <li className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                                ✓
                            </div>
                            <p className="text-gray-800 font-medium">Slow page load times and difficult navigation</p>
                        </li>
                        <li className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                                ✓
                            </div>
                            <p className="text-gray-800 font-medium">Poorly targeted keywords or no targeted keywords at al</p>
                        </li>
                        <li className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                                ✓
                            </div>
                            <p className="text-gray-800 font-medium">Content that fails to attract or engage visitors
                            </p>
                        </li>
                        <li className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                                ✓
                            </div>
                            <p className="text-gray-800 font-medium">Local customers can’t find your business online</p>
                        </li>
                        <li className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                                ✓
                            </div>
                            <p className="text-gray-800 font-medium">Ecommerce sites not ranking for critical products</p>
                        </li>
                    </ul>

                    {/* Inline CTA */}
                    <div className="mt-10">
                        <a
                            href="https://mean3.com/contact-mean3/"
                            className="inline-block bg-[#DA2128] text-white py-2 px-6 rounded-md font-semibold hover:bg-red-700 transition"
                        >
                            Schedule a Call With Us
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
